wbApp.controller('RentItemTabsRentsCtrl', ['$scope', '$modal', '$translate', '$filter', 'rentSvc',
function ($scope, $modal, $translate, $filter, rentSvc) {

    var selectedRentItem = null;

    $scope.rents = [];

    var isActive = true;
    var loaded = false;

    $scope.$on('rentItemSelectionChanged', function (e, newlySelectedRentItem) {
        if (newlySelectedRentItem) {
            if (isActive) {
                loadData(newlySelectedRentItem);
            } else {
                loaded = false;
            }
        }
        else {
            $scope.leadNotes = [];
            fullLead = null;
        }

        selectedRentItem = newlySelectedRentItem;
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 0) {
            if (!isActive) {
                isActive = true;
                if (!loaded && selectedRentItem) {
                    loadData(selectedRentItem);
                }
            }
        } else {
            isActive = false;
        }
    });

    function loadData(rentItem) {
        $scope.rents = [];

        if (!!rentItem) {

            var fromDateUtc = moment().subtract(3, 'month').startOf('day').toDate();
            var totoDateUtc = moment().add(1, 'month').startOf('day').toDate();

            rentSvc.getAllByPlaceAndItemAndDateRange(rentItem.placeId, rentItem.id, fromDateUtc, totoDateUtc)
                .$promise.then(function (data) {
                    fullLead = data;
                    $scope.rents = data;
                    loaded = true;
            }, function (error) {
                fullLead = null;
                $scope.rents = [];
                loaded = false;
            });
        }
    }


    $scope.rentsGridSettings = {
        name: 'rents',
        columns: [
            { dataField: 'id', caption: $translate.instant('TXT_LBL_ID'), dataType: 'string', visible: false },
            {
                dataField: 'condition',
                caption: '',
                dataType: 'string',
                encodeHtml: false,
                width: '42px',
                alignment: 'center',
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: {
                            type: 'array',
                            data: [
                                { id: 0, name: $translate.instant('TXT_ITEM_CONDITION_TYPE_READY_FOR_RENTING') },
                                { id: 1, name: $translate.instant('TXT_ITEM_CONDITION_NOT_READY') }
                            ],
                            key: "id"
                        },
                        pageSize: 10,
                        paginate: false
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
                calculateCellValue: function (rowData) {
                    var isOverallConditionGreen = _.reduce(rowData.rentedItems, function (sum, rentedItem) {
                        return sum && rentedItem.itemCondition == 0;
                    }, true);
                    return isOverallConditionGreen ? 0 : 1;
                },
                calculateDisplayValue: function (rowData) {

                    // ReadyForRenting,
                    // Broken,
                    // Maintenance,
                    // Decommissioned

                    // Only for future rents
                    var momentNow = moment();
                    var isOverallConditionGreen = moment(rowData.toUtc).isBefore(momentNow)
                        ? true
                        : _.reduce(rowData.rentedItems, function (sum, rentedItem) {
                            return sum && rentedItem.itemCondition == 0;
                        }, true);

                    if (isOverallConditionGreen) {
                        return "<i class='fa fa-check-circle text-success' aria-hidden='true'></i>";
                    } else {
                        return "<i class='fa fa-exclamation-triangle text-danger' aria-hidden='true'></i>";
                    }
                },
            },
            {
                dataField: 'rentedItems',
                caption: $translate.instant('TXT_MENU_RENT_ITEMS'),
                dataType: 'string',
                calculateDisplayValue: function (rowData) {
                    return _.join(_.map(rowData.rentedItems, function (rentedItem) {
                        if (!!rentedItem.externalId) {
                            return rentedItem.rentItemName + ' (' + rentedItem.externalId + ')' + ' - ' + rentedItem.rentCategoryName;
                        } else {
                            return rentedItem.rentItemName + ' - ' + rentedItem.rentCategoryName;
                        }
                    }), ', ');
                },
            },
            {
                showInColumnChooser: false,
                caption: '',
                dataField: 'isNotRegisteredUser',
                width: '42px',
                alignment: 'center',
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: {
                            type: 'array',
                            data: [
                                { id: true, name: $translate.instant('TXT_ANONYMOUS_USER') },
                                { id: false, name: $translate.instant('TXT_REGISTERED_USER') }
                            ],
                            key: "id"
                        },
                        pageSize: 10,
                        paginate: false
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
                encodeHtml: false,
                calculateSortValue: function (rowData) { return rowData.marker; },
                calculateDisplayValue: function (rowData) {
                    if (typeof rowData.isNotRegisteredUser === 'undefined' || rowData.isNotRegisteredUser === null) {
                        return "";
                    } else {
                        var icon = !!rowData.isNotRegisteredUser ? 'fa-user-o' : 'fa-user';
                        var res = "<i class='fa " + icon + "' aria-hidden='true'></i>";

                        return res;
                    }
                },
            },
            {
                dataField: 'userFullName',
                caption: $translate.instant('TXT_VAL_RCPG_USER'),
                width: '140px',
                dataType: 'string',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'userFullName') }
            },
            {
                dataField: 'studentsFullName',
                caption: $translate.instant('TXT_LBL_STUDENT'),
                dataType: 'string',
                width: '140px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'studentsFullName') }
            },
            { dataField: 'studentBirthday', caption: $translate.instant("TXT_LBL_BIRTHDAY"), dataType: 'date', format: { date: 'short' }, width: '70px' },
            {
                dataField: 'phone',
                caption: $translate.instant('TXT_LBL_PHONE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('phone')(rowData.phone);
                },
                width: '130px'
            },
            {
                dataField: 'email',
                caption: $translate.instant('TXT_LBL_EMAIL'),
                dataType: 'string',
                visible: true,
                width: '190px'
            },
            { dataField: 'fromUtc', caption: $translate.instant('TXT_LBL_FROM'), dataType: 'date', format: { type: 'shortDateShortTime' }, width: '120px', sortOrder: 'desc' },
            { dataField: 'toUtc', caption: $translate.instant('TXT_LBL_TO'), dataType: 'date', format: { type: 'shortDateShortTime' }, width: '120px' },
            {
                dataField: 'status',
                caption: $translate.instant('TXT_RENT_STATUS'),
                dataType: 'string',
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: {
                            type: 'array',
                            data: [
                                { id: 0, name: $translate.instant('TXT_RENT_STATUS_RESERVED') },
                                { id: 1, name: $translate.instant('TXT_RENT_STATUS_CANCELED') },
                                { id: 2, name: $translate.instant('TXT_RENT_STATUS_RENTED') },
                                { id: 3, name: $translate.instant('TXT_RENT_STATUS_RETURNED') },
                                { id: 4, name: $translate.instant('TXT_RENT_STATUS_NOT_RETURNED') },
                                { id: 5, name: $translate.instant('TXT_RENT_STATUS_RETURNED_WITH_ISSUES') },
                            ],
                            key: "id"
                        },
                        pageSize: 10,
                        paginate: false
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
                width: '100px'
            },
            { dataField: 'updatedAtUtc', caption: $translate.instant('TXT_LBL_UPDATED_AT'), dataType: 'date', format: { type: 'shortDateShortTime' }, width: '120px' },
        ],
        onEditorPreparing: function (e) {
            if (e.parentType == 'filterRow' && e.dataField == 'isNotRegisteredUser') {
                e.editorOptions.itemTemplate = function (itemData, itemIndex, itemElement) {
                    if (itemIndex == 0) {
                        return $("<i class='fa fa-user-circle' aria-hidden='true'></i>");
                    } else {
                        var icon = itemIndex == 1 ? 'fa-user-o' : 'fa-user';
                        var res = "<i class='fa " + icon + "' aria-hidden='true'></i>";

                        return res;
                    }
                }
            }
            if (e.parentType == 'filterRow' && e.dataField == 'condition') {
                e.editorOptions.itemTemplate = function (itemData, itemIndex, itemElement) {
                    if (itemIndex == 0) {
                        return $("<i class='fa fa-circle-o' aria-hidden='true'></i>");
                    } else {
                        if (itemIndex == 1) {
                            return "<i class='fa fa-check-circle text-success' aria-hidden='true'></i>";
                        }
                        else {
                            return "<i class='fa fa-exclamation-triangle text-danger' aria-hidden='true'></i>";
                        }
                    }
                }
            }
        }
    }

}]);
